import { createSafeContext } from '@mews/framework';

export const { CurrentServiceIdContextProvider, useCurrentServiceIdContext } = createSafeContext<
    'CurrentServiceIdContext',
    string
>('CurrentServiceIdContext');
